import {IStepOption} from 'ngx-ui-tour-md-menu';

export const TOUR_STEPS_SCREENING: IStepOption[] = [
  {
    anchorId: 'add-paper-btn',
    title: 'Add manual paper',
    content: 'You can add a paper manually by clicking the button above.',
  },
  {
    anchorId: 'find-paper-btn',
    title: 'Find paper',
    content:
      'After query is generated, you can find a research paper online by clicking the button above.',
  },
  {
    anchorId: 'query-settings-btn',
    title: 'Search query',
    content:
      'You can change the screening queries by clicking the button above.',
  },
  {
    anchorId: 'start-screening-btn',
    title: 'Start screening',
    content:
      'You can start screening the papers by clicking the button above.',
  },
  {
    anchorId: 'screening-results-btn',
    title: 'Screening results',
    content:
      'You can see the screening results by clicking the button above.',
  },
  {
    anchorId: 'download-paper-btn',
    title: 'Download results',
    content:
      'You can download the screening results by clicking the button above.',
  },
  {
    anchorId: 'screening-settings-btn',
    title: 'Screening settings',
    content:
      'You can change the screening queries by clicking the button above.',
  },
  {
    anchorId: 'paper-list-filter',
    title: 'Paper list filter',
    content:
      'You can filter the papers by clicking the filter buttons',
  },
];
